module.exports = __webpack_public_path__ + "fonts/Rubik-SemiBold.1be1980.woff";